<template>
    <div class="home container" :class="$vuetify.breakpoint.xsOnly ? 'px-0' : ''">
        <background-parallax :backgroundOpacityProp="'0.6'" />
        <div class="mt-12 pt-12" style="position: relative;"></div>
        <v-sheet class="mb-12 py-12 box box-rounded box-transparent box-transparent-dark" elevation="6">
            <h1 class="page-header display-1 font-weight-medium white--text">
                Service My Car
                <br v-if="$vuetify.breakpoint.xsOnly" />
                Policy
            </h1>
        </v-sheet>

        <v-card class="smc-box box box-rounded box-transparent box-transparent-light" elevation="12">
            <v-card-text class="text-left">
                <div v-if="loading" class="text-center py-12">
                    <v-progress-circular :size="50" indeterminate color="primary" />
                </div>
                <div v-else-if="errorMessage" class="text-center py-12 error--text">
                    {{ errorMessage }}
                </div>
                <div v-else class="terms-content" v-html="termsContent"></div>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import backgroundParallax from '@/components/widgets/background-parallax';
import { authService } from '@/services';

export default {
    name: 'terms',
    components: {
        backgroundParallax,
    },
    data: () => ({
        loading: true,
        termsContent: '',
        errorMessage: '',
    }),
    async mounted() {
        await this.loadTerms();
    },
    methods: {
        async loadTerms() {
            this.loading = true;
            this.errorMessage = '';

            let result = await authService.getCurrentTerms();
            if (result && result.status === 200 && result.data && result.data.content) {
                this.termsContent = result.data.content;
            }
            else {
                this.errorMessage = 'We were unable to load our terms and conditions. Please try again later.';
            }

            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.terms-content ::v-deep {
  h1, h2, h3, h4, h5, h6 {
    font-weight: 500;
    margin-bottom: 16px;
  }

  p, ol, ul {
    margin-bottom: 16px;
  }

  ol, ul {
    padding-left: 1.5em;
  }

  li {
    margin-bottom: 8px;
  }
}
</style>
